import { Logger, type ILogObj, } from "tslog";

//0: silly, 1: trace, 2: debug, 3: info, 4: warn, 5: error, 6: fatal

export declare type MinLogLevel = 0 | 1 | 2 | 3 | 4 | 5 | 6;
export declare type MinLogLevelName = "silly" | "trace" | "debug" | "info" | "warn" | "error" | "fatal";

export const createLogger = ({ level = 0, name = "bracket" }: { level?: MinLogLevel, name?: string } = {}): Logger<ILogObj> => {
	if(import.meta.env) {
		const { PROD, PROD_URL, } = import.meta.env;
		const { hostname, } = globalThis.location ?? {};
		const minLevel = ( PROD ?? PROD_URL === hostname ? 5 : level ?? 0 ) as number;
		const logger = new Logger<ILogObj>({
			name,
			type: "pretty",
			minLevel,
			prettyLogTemplate: "{{mm}}/{{dd}} {{hh}}:{{MM}}:{{ss}}\t{{logLevelName}}\t[{{name}}]\t",
		});
		return logger;
	}
	console.warn("createLogger: no import.meta.env found, using default logger");
	return console as unknown as Logger<ILogObj>;
};

export const logger = createLogger();
